import CaptchaProvider from './CaptchaProvider';

export default class AltchaProvider extends CaptchaProvider {
    constructor(element, verifyCallback, config = {}) {
        super(element, verifyCallback, config);
        this.challengeUrl = config.challengeUrl;
        this.widgetElement = null;
    }

    async initialize(slug, chToken) {
        this.slug = slug;
        this.chToken = chToken;
        
        await this.loadAltchaScript();
    }

    loadAltchaScript() {
        return new Promise((resolve, reject) => {
            // Check if already loaded
            if (window.AltchaUMD && window.AltchaUMD.isLoaded()) {
                this.render();
                resolve();
                return;
            }

            // Load the UMD wrapper
            const script = document.createElement('script');
            script.src = 'https://wait.crowdhandler.com/js/altcha-umd.js';
            script.async = true;
            
            script.onload = async () => {
                try {
                    // Load Altcha through the UMD wrapper
                    await window.AltchaUMD.load();
                    this.render();
                    resolve();
                } catch (error) {
                    console.error('Failed to initialize Altcha:', error);
                    reject(error);
                }
            };
            
            script.onerror = () => {
                console.error('Failed to load Altcha UMD wrapper');
                reject(new Error('Failed to load Altcha UMD wrapper'));
            };
            
            document.head.appendChild(script);
        });
    }

    async render() {
        if (!this.element) {
            console.error('No element provided for Altcha widget');
            return;
        }

        // Create Altcha widget element
        this.widgetElement = document.createElement('altcha-widget');
        
        // Set challengeurl attribute - this will need to be configured
        // to point to your Altcha server endpoint
        if (this.challengeUrl) {
            this.widgetElement.setAttribute('challengeurl', this.challengeUrl);
        }

        // Listen for state changes
        this.widgetElement.addEventListener('statechange', (event) => {
            if (event.detail && event.detail.state === 'verified') {
                // Get the payload from the event
                const payload = event.detail.payload;
                this.verify(payload);
            }
        });

        // Clear existing content and append widget
        this.element.innerHTML = '';
        this.element.appendChild(this.widgetElement);
        
        this.widgetId = this.widgetElement;
    }

    async reset() {
        if (this.widgetElement && typeof this.widgetElement.reset === 'function') {
            try {
                this.widgetElement.reset();
            } catch (error) {
                console.debug('Altcha reset error:', error);
            }
        }
        
        this.isValidated = false;
        this.token = null;
    }

    destroy() {
        super.destroy();
        
        if (this.widgetElement && this.widgetElement.parentNode) {
            this.widgetElement.parentNode.removeChild(this.widgetElement);
        }
        
        this.widgetElement = null;
    }
}